<div *ngIf='componentReady' [formGroup]='formGroup' class='CreateContact p-0 p-sm-5'>
  <div
    class='CreateContact__header d-flex flex-column flex-sm-row justify-content-between align-items-center mb-5'>
    <div class='Breadcrumbs'>
      <div class='Breadcrumbs-items'>
        <a
          [routerLink]="userSession.user_type === 'vsm' ? ['/messages', 'view', fromMessage, {from: 'inbox', vsm_remaining_time: vsmRemainingTime}] : ['/user_contacts', 'user_groups']"
        >
          <mat-icon class='Breadcrumbs-icon back'
          >keyboard_backspace
          </mat-icon
          >
        </a
        >
        <a
          [routerLink]="userSession.user_type === 'vsm' ? ['/messages', 'view', fromMessage, {from: 'inbox', vsm_remaining_time: vsmRemainingTime}] : ['/user_contacts', 'user_groups']"
          class='Breadcrumbs-item first'>{{
            state === 'edit'
              ? canEditContact
                ? (userSession.user_type === 'vsm' ? 'View message' : 'Edit Existing Contact')
                : 'View Contact'
              : 'Add User Contact'
          }}</a>
        <app-info-tip-button [type]="'add_contacts'" class='d-none d-sm-block'></app-info-tip-button>
        <ng-container *ngIf="canEditContact && state !== 'create'">
          <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
          <span class='Breadcrumbs-item'>{{
              formGroup.get('email').value
            }}</span>
        </ng-container>
      </div>
    </div>
    <div *ngIf="canEditContact && state === 'create'">
      <mat-checkbox formControlName='send_email'
      >Check to send custom email
      </mat-checkbox
      >
      <fa-icon
        [icon]='iconQuestionCircle'
        [popoverAnimation]='true'
        [popoverDisabled]='false'
        [popoverOnHover]='true'
        [popoverPlacement]="'right'"
        [popover]='tooltipText'
        class='CreateContact-header-fa ms-2'></fa-icon>
    </div>
    <app-button
      [Click]='addButtonProperties.onClick'
      [color]='addButtonProperties.color'
      [disabled]='emailAddressValid !== true'
      [observeApi]='true'
      [size]='addButtonProperties.size'
      [text]='getSubmitButtonText()'></app-button>
  </div>
  <div class="ContactCreate__body__row">
      <div
          *ngIf='lockedBannerState === locketBannerStates.SELF'
          [class.alert-danger]='vsmRemainingTime < 10 * 1000'
          [class.alert-info]='vsmRemainingTime >= 10 * 1000'
          class='alert'>
          <p class='mb-0'>
            Message {{ fromMessage }} have been locked for you only. You have
            <b>{{ vsmRemainingMinutes }}:{{ vsmRemainingSeconds }}</b> to work on
            it!
          </p>
        </div>
    </div>
  <div class='CreateContact__body p-0 p-sm-5'>
    
    <div class='CreateContact__body__row'>
      <div class='CreateContact__body__row__title'>
        <h3>Contact Details</h3>
      </div>
      <div class='CreateContact__body__row__content'>
        <ng-container
          *ngIf='userSession.user_type !== "partner" && userSession.user_type !== "manager" && userSession.user_type !== "vsm" && canViewGroup; else noGroupSelection'
        >
          <app-select
            (selection)='onGroupSelection($event)'
            [colorWhite]='true'
            [items]='contactGroupsItems'
            formControlName='group_id'
            label='Select Existing group'
            required></app-select>
          <div
            *ngIf="
            getControl('group_id').touched &&
            getControl('group_id').dirty &&
            getControl('group_id').errors
          "
            class='alert alert-danger'>
            <p *ngIf="getControl('group_id').errors.required">
              Group selection is required!
            </p>
          </div>
          <div *ngIf='showGroupControl'>
            <app-text-field
              (focusout)='checkNewGroup($event.target.value)'
              [fieldBackgroundClass]="'white'"
              formControlName='group_name'
              placeholder='Group name'></app-text-field>
            <div
              *ngIf="
              getControl('group_name').touched &&
              !getControl('group_name').valid &&
              getControl('group_name').errors
            "
              class='alert alert-danger'>
              <p *ngIf="getControl('group_name').errors.required">
                Group name is required!
              </p>
            </div>
          </div>
        </ng-container>
        <ng-template #noGroupSelection>
          <p>Selected Group: {{ contactData.group_name }}</p>
        </ng-template>

        <div class='d-flex flex-row align-items-center flex__row__items'>
          <div
            [class.no__margin__right]="state !== 'edit' || !canEditContact"
            class='flex-grow-1'>
            <app-text-field
              (focusout)='checkEmailAddress($event.target.value)'
              [fieldBackgroundClass]="'white'"
              [canCopy]="true"
              formControlName='email'
              placeholder='Email'></app-text-field>
          </div>
          <div *ngIf="state === 'edit' && canEditContact" class='flex-grow-0'>
            <app-button
              (click)='toggleAlternativeEmails()'
              [color]="'blue'"
              [disabled]='disableEmailEdit'
              [style]="'outline'"
              [text]="showAlternativeEmails ? 'Hide' : 'Update Email'">
            </app-button>
          </div>
          <div
            *ngIf="
              emailValidationTriggered || (state === 'edit' && canEditContact)
            "
            class='flex-grow-0'>
            <span>
              <mat-spinner
                *ngIf='emailValidationInProgress'
                class='CreateContact-form-spinner'
                color='primary'
                diameter='20'
                mode='indeterminate'>
              </mat-spinner>
              <fa-icon
                *ngIf='emailAddressValid'
                [icon]='iconCheck'
                [popoverAnimation]='true'
                [popoverDisabled]='false'
                [popoverOnHover]='true'
                [popoverPlacement]="'right'"
                [popover]="'Email address is valid'"
                class='CreateContact-form-valid'
                size='2x'></fa-icon>
              <fa-icon
                *ngIf='emailAddressValid === false'
                [icon]='iconTimes'
                [popoverAnimation]='true'
                [popoverDisabled]='false'
                [popoverOnHover]='true'
                [popoverPlacement]="'right'"
                [popover]="'Email address is invalid'"
                class='CreateContact-form-invalid'
                size='2x'></fa-icon>
            </span>
          </div>
        </div>
        <div
          *ngIf="
            getControl('email').touched &&
            getControl('email').dirty &&
            !getControl('email').valid &&
            getControl('email').errors
          "
          class='alert alert-danger'>
          <p *ngIf="getControl('email').errors.validation">
            {{ getControl('email').errors.validation }}
          </p>
          <p *ngIf="getControl('email').errors.required">
            Email address is required!
          </p>
          <p *ngIf="getControl('email').errors.email">
            Please, enter valid email address!
          </p>
        </div>
        <div *ngIf='showAlternativeEmails'>
          <app-text-field
            [fieldBackgroundClass]="'white'"
            formControlName='alternate_email_1'
            placeholder='Alternative email 1'></app-text-field>
          <div
            *ngIf="
              getControl('alternate_email_1').touched &&
              !getControl('alternate_email_1').valid &&
              getControl('alternate_email_1').errors
            "
            class='alert alert-danger'>
            <p *ngIf="getControl('alternate_email_1').errors.validation">
              {{ getControl('alternate_email_1').errors.validation }}
            </p>
            <p *ngIf="getControl('alternate_email_1').errors.email">
              Please, enter valid email address!
            </p>
          </div>
        </div>
        <div *ngIf='showAlternativeEmails'>
          <app-text-field
            [fieldBackgroundClass]="'white'"
            formControlName='alternate_email_2'
            placeholder='Alternative email 2'></app-text-field>
          <div
            *ngIf="
              getControl('alternate_email_2').touched &&
              !getControl('alternate_email_2').valid &&
              getControl('alternate_email_2').errors
            "
            class='alert alert-danger'>
            <p *ngIf="getControl('alternate_email_2').errors.validation">
              {{ getControl('alternate_email_2').errors.validation }}
            </p>
            <p *ngIf="getControl('alternate_email_2').errors.email">
              Please, enter valid email address!
            </p>
          </div>
        </div>
        <div *ngIf='showAlternativeEmails'>
          <app-text-field
            [fieldBackgroundClass]="'white'"
            formControlName='alternate_email_3'
            placeholder='Alternative email 2'></app-text-field>
          <div
            *ngIf="
              getControl('alternate_email_3').touched &&
              !getControl('alternate_email_3').valid &&
              getControl('alternate_email_3').errors
            "
            class='alert alert-danger'>
            <p *ngIf="getControl('alternate_email_3').errors.validation">
              {{ getControl('alternate_email_3').errors.validation }}
            </p>
            <p *ngIf="getControl('alternate_email_3').errors.email">
              Please, enter valid email address!
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class='CreateContact__body__row'>
      <div class='CreateContact__body__row__title'>
        <h3>Custom fields</h3>
      </div>
      <div class='CreateContact__body__row__content'>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='firstname'
          placeholder='First name'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='lastname'
          placeholder='Last name'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='company'
          placeholder='Company'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='title'
          placeholder='Title'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='private_note'
          placeholder='Private note'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='tags'
          placeholder='Tags'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='address1'
          placeholder='Address 1'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='address2'
          placeholder='Address 2'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='city'
          placeholder='City'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='state'
          placeholder='State'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='phone_number'
          placeholder='Phone'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='mobile_phone'
          placeholder='Mobile Phone'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='fax'
          placeholder='Fax'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='zip_code'
          placeholder='Zip code'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='level'
          placeholder='Level'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='department1'
          placeholder='Department 1'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='department2'
          placeholder='Department 2'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='department3'
          placeholder='Department 3'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='company_address'
          placeholder='Company street address'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='company_city'
          placeholder='Company city'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='company_state'
          placeholder='Company State'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='company_zip'
          placeholder='Company zip code'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='company_url'
          placeholder='Company URL'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='stock_exchange'
          placeholder='Stock exchange'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='ticker_symbol'
          placeholder='Ticket symbol'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='revenue'
          placeholder='Revenue'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='employees'
          placeholder='Employees'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='industry1'
          placeholder='Industry 1'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='industry2'
          placeholder='Industry 2'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='industry3'
          placeholder='Industry 3'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='sub_industry1'
          placeholder='Subindustry 1'></app-text-field>
        <app-text-field
          [fieldBackgroundClass]="'white'"
          formControlName='sub_industry2'
          placeholder='Subindustry 2'></app-text-field>
        <app-text-field
          *ngIf='v1'
          [fieldBackgroundClass]="'white'"
          [placeholder]='v1Label'
          formControlName='variable1'></app-text-field>
        <app-text-field
          *ngIf='v2'
          [fieldBackgroundClass]="'white'"
          [placeholder]='v2Label'
          formControlName='variable2'></app-text-field>
        <app-text-field
          *ngIf='v3'
          [fieldBackgroundClass]="'white'"
          [placeholder]='v3Label'
          formControlName='variable3'></app-text-field>
      </div>
    </div>
    <div *ngIf='canEditContact'>
      <app-button
        [Click]='addButtonProperties.onClick'
        [color]='addButtonProperties.color'
        [disabled]='emailAddressValid !== true'
        [observeApi]='true'
        [size]='addButtonProperties.size'
        [text]='getSubmitButtonText()'></app-button>
    </div>
  </div>
</div>
